import { render } from "./Banner.vue?vue&type=template&id=38a78aec"
import script from "./Banner.vue?vue&type=script&scoped=true&lang=js"
export * from "./Banner.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__